import { getOidcClientId, getOidcUserStorageKey } from './oidcConfig';

export const OIDC_CLIENT_ID = getOidcClientId();

/** Must match `main.tsx` AuthProvider `authority` + `client_id`. */
export function oidcUserStorageKey(): string {
  return getOidcUserStorageKey();
}

export function persistOidcUserJson(userJson: string): void {
  if (!userJson?.trim()) return;
  localStorage.setItem(oidcUserStorageKey(), userJson);
}

export function readOidcUserJson(): string | null {
  return localStorage.getItem(oidcUserStorageKey());
}
